import React, {useEffect, useState} from "react";
import { PanelEditCategory } from "../../../UI/Categories/Edit/PanelEditCategory";
import {useParams} from "react-router-dom";
import {Helper} from "../../../tools/Helper";
import {api_Routes} from "../../../tools/api_Routes";
import PanelHead from "../../../UI/Panel/PanelHead";
import {CircularProgress, LinearProgress} from "@mui/material";
import PanelBody from "../../../UI/Panel/PanelBody";
import AddBalanceReviewPage from "../../../UI/AddBalanceRequests/AddBalanceReview";


const EditBalanceRequest = () => {
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [formData, setFormData] = useState({});

    const getData = async () => {
        try {
            const { result, response } = await Helper.Get({
                url: `${api_Routes.AddBalanceRequests.GetOne}${id}`,
            });
            if (response) {
                setFormData(response?.data);
            }
        } catch (error) {
            console.error("Error fetching details:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getData();
    }, []);
  return (
      <div>
          <PanelHead
              title={
                  isLoading ? (
                      <div className="flex items-center gap-4">
                          Balance Request details <CircularProgress size={24} />
                      </div>
                  ) : (
                      <div className="flex items-center justify-between w-full gap-4">
                          <div>Balance Request details: {formData?.id}</div>
                      </div>
                  )
              }
          />
          <PanelBody
              content={
                  isLoading ? (
                      <LinearProgress />
                  ) : (
                      <AddBalanceReviewPage data={formData} refetch={getData} />
                  )
              }
          />
      </div>
  );
};

export default EditBalanceRequest;
